import { render, staticRenderFns } from "./ToggleSelectProviderDesktop.vue?vue&type=template&id=33f4121e"
import script from "./ToggleSelectProviderDesktop.vue?vue&type=script&lang=js"
export * from "./ToggleSelectProviderDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports